import { ApiError } from '../../lib/api';

/**
 * Unde s-a vrut să se ajungă înainte de redirecționarea către login.
 *
 * ⚠️ **Se acceptă doar căi interne.** Fără verificare, `/login?redirect=https://exemplu.ro`
 * ar transforma pagina de autentificare într-un redirector deschis: linkul arată ca al
 * nostru, dar te lasă pe alt site imediat după ce ai scris parola. `//` e respins tot
 * aici — `//evil.ro` e o adresă absolută, cu protocolul moștenit din pagina curentă.
 */
export function safeRedirect(value: string | undefined): string | undefined {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return undefined;
  }

  return value;
}

/**
 * Traduce codul de la server în ce trebuie să citească operatorul.
 *
 * Se ramifică pe `code`, nu pe mesaj: mesajele se rescriu, codurile nu. „Utilizator sau
 * parolă greșite" rămâne nediferențiat și aici — serverul nu spune care din două, iar
 * frontend-ul n-are cum să ghicească mai bine.
 */
export function loginErrorMessage(error: unknown): string {
  if (!(error instanceof ApiError)) {
    return 'Serverul nu răspunde. Încearcă din nou.';
  }

  switch (error.code) {
    case 'invalid_credentials':
      return 'Utilizator sau parolă greșite.';
    case 'account_locked':
      return 'Contul e blocat temporar după prea multe încercări. Încearcă peste câteva minute.';
    case 'account_disabled':
      return 'Contul este dezactivat. Cere-i unui administrator să-l reactiveze.';
    default:
      return error.message;
  }
}
